var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { selectBalancingShopOfferGroupById } from "../../balancingSelectors/selectBalancingPurchaseOfferGroups";
import { selectResourceAmountInfo } from "../../balancingSelectors/selectBalancingResources";
import { IdResource } from "../../constants/IdResource";
import { IdStyles } from "../../less/IdStyles";
import { selectCurrentDialogGift, selectCurrentDialogGiftResourceData, selectIsTournamentGiftDialogDisabled, } from "../../selectors/selectTournamentRewards";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { utilOffers } from "../../utils/utilOffers";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { actionGameTrackingShopPackageSelect } from "../game-tracking/shop/actionGameTrackingShop";
import { actionModalClose, actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { LeagueRewardSpecialOfferButton } from "./LeagueRewardSpecialOfferButton";
import { LeagueRewardSpecialOfferHeader } from "./LeagueRewardSpecialOfferHeader";
import { LeagueRewardSpecialOfferItems } from "./LeagueRewardSpecialOfferItems";
export var _DialogLeagueRewardSpecialOffer = function (_a) {
    var currentGiftItems = _a.currentGiftItems, onClose = _a.onClose, fullGroupOffer = _a.fullGroupOffer, shopPackage = _a.shopPackage, onOfferSelect = _a.onOfferSelect, isDisabled = _a.isDisabled, requiredLeague = _a.requiredLeague;
    if (fullGroupOffer === undefined || fullGroupOffer.purchaseOffer[0] === undefined) {
        return React.createElement(React.Fragment, null);
    }
    var itemsToDisplayInList = currentGiftItems.filter(function (value) { return value.resource.id !== IdResource.Gold; });
    // we slice the first item, which is the gold shown in the heading.
    var rewards = currentGiftItems
        .slice(1)
        .map(function (value) { return selectResourceAmountInfo(value.resource.id, value.amount || Long.ZERO); });
    var specialOfferHeaderProps = {
        baseGoldValue: currentGiftItems[0].amount || Long.ZERO,
        bonusGoldPercent: fullGroupOffer.purchaseOffer[0].bonusGoldPercent,
        primeTimeBonus: undefined,
        rewards: rewards,
        subscriptionBonus: undefined,
        webBonusGold: fullGroupOffer.purchaseOffer[0].webBonusGold || 0,
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DialogWrapper, { titleLocaId: IdLoca.leagueRewardOfferTitle, onClose: onClose, className: IdStyles.ModalBackgroundLeagueReward },
            React.createElement("div", { className: "dialog-league-reward-special-offer__main-wrapper flex flex--stacked flex--spaced" },
                React.createElement(LeagueRewardSpecialOfferHeader, __assign({}, specialOfferHeaderProps)),
                React.createElement(LeagueRewardSpecialOfferItems, { currentGiftItems: itemsToDisplayInList }),
                React.createElement(LeagueRewardSpecialOfferButton, { shopPackage: shopPackage, onClick: function () { return onOfferSelect(fullGroupOffer.name); }, disabled: isDisabled, requiredLeague: requiredLeague })))));
};
var mapState = function (state) {
    var currentGift = selectCurrentDialogGift(state);
    var fullGroupOffer = selectBalancingShopOfferGroupById(currentGift.id);
    var shopPackage = utilOffers.matchPurchaseOfferGroupToWebCatalog(fullGroupOffer, state.shop.catalog.packages || []);
    return {
        currentGiftItems: selectCurrentDialogGiftResourceData(state),
        fullGroupOffer: fullGroupOffer,
        isDisabled: selectIsTournamentGiftDialogDisabled(state),
        requiredLeague: currentGift.giftLevel,
        shopPackage: shopPackage,
    };
};
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.LeagueRewardSpecialOffer)); },
    onOfferSelect: function (id) {
        dispatch(actionModalOpen(IdModal.ConfirmBuyTournamentSpecialOffer));
        dispatch(actionGameTrackingShopPackageSelect(id));
    },
}); };
export var DialogLeagueRewardSpecialOffer = connect(mapState, mapDispatch)(_DialogLeagueRewardSpecialOffer);



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/DialogLeagueRewardSpecialOffer.tsx
// module id = 2948
// module chunks = 3